<template>
    <div id="app" style="background-color:  white;">
        <router-view />
    </div>
</template>

<script>
export default {
    computed: {
        // 
    },
    methods: {
        // 
    },
    // mounted() {
    //     //
    // },
    // unmounted() {
    //     //
    // },
};
</script>
